import 'normalize.css';
import '@/style/fonts.css';
import '@/style/base.css';
import '@/modules/i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { initializeTheme } from '@/modules/theme';

// The static <title> and og:title in index.html are fallbacks for scrapers without JS; PageMeta renders the live ones
document.head.querySelectorAll('[data-spa-fallback]').forEach((node) => node.remove());

// The pre-paint script in index.html set only the class; this adds color-scheme and theme-color before the first render
initializeTheme();

const root = document.getElementById('root');
if (!root) {
    throw new Error('#root element is missing in index.html');
}
createRoot(root).render(
    <StrictMode>
        <App/>
    </StrictMode>,
);
